import { useField } from 'formik';
import { PROOF_INTRO_TEXT } from 'modules/review/components/ProofDocumentModal';
import { ProofDocumentSelector } from 'modules/review/components/ProofDocumentSelector';
import React, { CSSProperties, FunctionComponent, useState } from 'react';
import { Button, Icon, Modal, Popup } from 'semantic-ui-react';

type Props = {
  fieldName: string;
  disabled?: boolean;
  style?: CSSProperties;
};

export const ReviewInvitationProofDocumentButton: FunctionComponent<Props> = ({
  fieldName,
  disabled = false,
  style,
}) => {
  const [{ value }, , { setValue }] = useField<File | undefined>(fieldName);
  const [isOpen, setIsOpen] = useState(false);

  const hasProof = Boolean(value);

  return (
    <>
      <Popup
        content={
          hasProof
            ? 'Modifier la preuve de prestation'
            : 'Attacher une preuve de prestation'
        }
        position="top center"
        trigger={
          <Button
            basic
            icon
            color={hasProof ? 'green' : 'blue'}
            disabled={disabled}
            type="button"
            style={style}
            onClick={(): void => setIsOpen(true)}
          >
            <Icon name="file alternate outline" />
          </Button>
        }
      />
      <Modal
        open={isOpen}
        onClose={(): void => setIsOpen(false)}
        closeIcon
        size="small"
      >
        <Modal.Header>Preuve de prestation</Modal.Header>
        <Modal.Content>
          <p style={{ marginTop: 0, marginBottom: '20px', lineHeight: 1.5 }}>
            {PROOF_INTRO_TEXT}
            <br />
            Il sera automatiquement rattaché à l&apos;avis lorsque le
            particulier le déposera via le lien d&apos;invitation.
          </p>
          <ProofDocumentSelector
            document={value}
            onDocumentChange={(file): void => {
              void setValue(file);
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button positive={hasProof} onClick={(): void => setIsOpen(false)}>
            {hasProof ? 'Confirmer' : 'Fermer'}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
